import { all } from "redux-saga/effects"
import read from "./read"
import available from "./available"
import add from "./add"
import remove from "./remove"

export default function*() {
  while (true) {
    yield all({
      read: read(),
      available: available(),
      add: add(),
      remove: remove(),
    })
  }
}
